module.exports = __webpack_public_path__ + "img/fastcharger-suggestion-semipublic.cfaba166.png";